module.exports = __webpack_public_path__ + "img/logo-title.2909daf5.png";